import { getAuthorities } from '.';
import { ROLE_COMERCIAL, ROLE_SISTEMA } from './enum';

const canCriarVenda = () => getAuthorities([ROLE_COMERCIAL, ROLE_SISTEMA]).length > 0;

export default canCriarVenda;
